class CartWatcher {
  constructor() {
    this.init();
  }

  init() {
    this.emitCartChanges()
      .then(() => this.observeCartChanges());
  }

  async fetchCart() {
    try {
      const response = await fetch("/cart.js");
      return response.json();
    } catch (error) {
      console.error("Error fetching cart:", error);
      throw error;
    }
  }

  storeCart(cartData) {
    localStorage.setItem("cart", JSON.stringify(cartData));
  }

  storedCart() {
    const storedCart = localStorage.getItem("cart");
    return storedCart ? JSON.parse(storedCart) : { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const added = newCart.items.filter(
      (newItem) => !oldCart.items.some((oldItem) => newItem.key === oldItem.key)
    );

    const removed = oldCart.items.filter(
      (oldItem) => !newCart.items.some((newItem) => newItem.key === oldItem.key)
    );

    // Check for quantity changes in existing items
    oldCart.items.forEach((oldItem) => {
      const matchingNewItem = newCart.items.find(
        (newItem) => newItem.key === oldItem.key && newItem.quantity !== oldItem.quantity
      );

      if (matchingNewItem) {
        const quantityChange = matchingNewItem.quantity - oldItem.quantity;
        const updatedItem = { ...oldItem, quantity: Math.abs(quantityChange) };

        if (quantityChange > 0) {
          added.push(updatedItem);
        } else {
          removed.push(updatedItem);
        }
      }
    });

    return { added, removed };
  }

  async emitCartChanges() {
    const fetchedCart = await this.fetchCart();
    const storedCart = this.storedCart();
    const cartChanges = this.findCartChanges(storedCart, fetchedCart);

    const cartChangedEvent = new CustomEvent("cart_changed", { detail: cartChanges });
    window.dispatchEvent(cartChangedEvent);

    this.storeCart(fetchedCart);
  }

  getCurrentTotal() {
    const storedCart = this.storedCart();
    return storedCart.items.reduce((total, item) => total + item.quantity * item.price, 0);
  }

  observeCartChanges() {
    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (
          ["xmlhttprequest", "fetch"].includes(entry.initiatorType) &&
          /\/cart\//.test(entry.name)
        ) {
          this.emitCartChanges();
        }
      });
    });

    observer.observe({ entryTypes: ["resource"] });
  }
}